var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6687 104.625H77.7937V87.4125H94.3312V3.375H13.6687V104.625Z",
    fill: "#F3F4F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9812 90.6187H81.1687V102.431L81.1704 102.429L92.9812 90.6187Z",
    fill: "#F3F4F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2937 0C12.0846 0 10.2937 1.79086 10.2937 4V104C10.2937 106.209 12.0846 108 14.2937 108H78.8369C79.8977 108 80.9151 107.579 81.6653 106.828L96.5346 91.9591C97.2848 91.2089 97.7062 90.1915 97.7062 89.1306V3.99999C97.7062 1.79085 95.9154 0 93.7062 0H14.2937ZM81.1687 102.431V90.6188H92.9812L81.1687 102.431ZM94.3312 87.4125H81.7937C79.5846 87.4125 77.7937 89.2034 77.7937 91.4125V104.625H13.6687V3.375H94.3312V87.4125Z",
    fill: "#787395"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6499 16.0312H82.1812V19.4062H25.6499V16.0312ZM25.6499 27.8438H82.1812V31.2188H25.6499V27.8438ZM25.6499 39.6562H82.1812V43.0312H25.6499V39.6562ZM25.6499 51.4688H82.1812V54.8438H25.6499V51.4688ZM25.6499 63.2812H82.1812V66.6562H25.6499V63.2812ZM25.6499 75.0938H82.1812V78.4688H25.6499V75.0938Z",
    fill: "#787395"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDefault);
export default __webpack_public_path__ + "static/media/document_default.d9dab800.svg";
export { ForwardRef as ReactComponent };